import  {   Component
        ,   Input
        ,   ViewChild
        ,   ElementRef                    } from '@angular/core';
import  {   User                          } from 'src/app/beans/login/user/user.bean';
import  {   HandlerManager                } from 'src/app/managers/handler/handler.manager';
import  {   LoadingManager                } from 'src/app/managers/loading/loading.manager';
import  {   SessionManager                } from 'src/app/managers/session/session.manager';
import  {   Observable
        ,   of                            } from 'rxjs';
import  {   FormControl                   } from '@angular/forms';
import  {   map
        ,   startWith                     } from 'rxjs/operators';
import  {   Site                          } from 'src/app/beans/site/site.bean';
import  {   MatAutocomplete
        ,   MatAutocompleteSelectedEvent
        ,   MatAutocompleteTrigger        } from '@angular/material/autocomplete';
import  {   COMMA                         
        ,   ENTER                         } from '@angular/cdk/keycodes';
import  {   Service                       } from 'src/app/beans/service/service.bean';

@Component({
  selector: 'site-autocomplete',
  templateUrl: './site.autocomplete.html',
  styleUrls: ['./site.autocomplete.scss']
})
export class SiteAutocomplete {

  orgId: number
  @Input('orgId') set _orgId(orgId: number)
  {    
    this.orgId = orgId
    if(orgId) this.init(orgId, this.service)
  }

  service: Service
  @Input('service') set _service(service: Service)
  {    
    this.service = service
    if(service) this.init(this.orgId, service)
  }

  visible           : boolean             = true              ;
  separatorKeysCodes: number[]            = [ENTER, COMMA]    ;
  siteCtrl          : FormControl         = new FormControl() ;
  filteredSites     : Observable<Site[]>                      ;
  sites             : Site[]              = []                ;
  allSites          : Site[]              = []                ;

  @ViewChild( 'siteInput'   ) siteInput       : ElementRef<HTMLInputElement>;
  @ViewChild( 'auto'        ) matAutocomplete : MatAutocomplete             ;

  @ViewChild( 'siteInput'   , { read: MatAutocompleteTrigger  } ) siteTrigger: MatAutocompleteTrigger;

  constructor(
    private _session: SessionManager,
    private _loader : LoadingManager,
    private _handler: HandlerManager
  ) {
    this.filteredSites = this.siteCtrl.valueChanges.pipe(
        startWith(null),
        map((site: string | null) => site ? this._filter(site) : this.getSubSet())
    );
  }

  async init( orgId ?: number, service ?: Service)
  {
    //Set operator list
    if(orgId && service){
      this.allSites = await this.retriveSiteList( orgId, service )
    }
  }

  async retriveSiteList( orgId: number, service: Service )
  {
    const user  = this._session.user().get()

    if (!User.isKind( user )) return // TODO handle user incorrect 

    this._loader.start()

    let response = null
    response = await this._handler.site().listByServiceCode(( user as User ).token, orgId, service.id, service.serviceCode, 1 )

    this._loader.stop()

    if ( !response        ) return
    if ( !response.list   ) return

    return response.list as Site[];
  }

  
  displayFn(site: Site): string 
  {
    return site && site.name ? site.name : '';
  }

  remove(site: Site): void {
    const index = this.sites.indexOf(site);

    if (index >= 0) {
      this.sites.splice(index, 1);
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    this.sites.push(event.option.value);
    this.siteInput.nativeElement.value = '';
    this.siteCtrl.setValue(null);

    this.focused()
    setTimeout( ()=>{ this.siteTrigger.openPanel()}, 100)
  }

  private getSubSet(){
    const subSet: Site[] = []
    if(!this.sites || this.sites.length == 0) return this.allSites
    this.allSites.forEach( site => {
      let find = this.sites.find ( s => s.id == site.id )
      if (!find) subSet.push( site )
    })
    return subSet
  }

  private _filter(value: string): Site[] {    
    if (!value || !(typeof value === 'string') ) return []
    const filterValue = value.toLowerCase();
    const subSet = this.getSubSet()
    return subSet.filter(site => site.name.toLowerCase().indexOf( filterValue ) >= 0);
  }

  getSelected(){
    return this.sites ? this.sites : []
  }

  focused(param?: any){
    const site = this.siteCtrl.value
    this.filteredSites = of( site ? this._filter(site) : this.getSubSet() )
  }
}
